import singleAdapter from '../resource/adapter'

const adapter = {
  responseBodyToRender(payload){
    let result = [];

    if (payload && payload.length > 0) {
      for (let index = 0; index < payload.length; index++) {
        const resource = payload[index];

        result.push(singleAdapter.responseBodyToRender(resource));
      }
    }

    return result;
  },
  responseBodyToOptions(payload){
    let result = [];

    if (payload && payload.length > 0) {
      for (let index = 0; index < payload.length; index++) {
        const element = payload[index];
        result.push({
          label: element.judulArtikel[0],
          value: element.resourceId,
        });
      }
    }

    return result;
  },
}

export default adapter
